document.addEventListener('DOMContentLoaded', function () {
    // Select all accordions in the 'subitems' group
    document.querySelectorAll('[data-accordion-group="subitems"]').forEach(function (accordion) {
        accordion.addEventListener('toggle', function () {
            if (accordion.open) {
                // Close all other accordions in the same group and parent
                accordion.parentElement.querySelectorAll('[data-accordion-group="subitems"]').forEach(function (other) {
                    if (other !== accordion) {
                        other.open = false;
                    }
                });
            }
        });
    });
});